@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");

:root {
  --editor-primary: #0669b3;
  --editor-text: #22272a;
  --editor-toolbar-bg: transparent;
  --editor-border: #dfe5ec;
  --editor-container-bg: #ffffff;
  --color-slate-default: #526581;
}

.ql-wrapper {
  border: 1.5px solid transparent;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.18s ease;
  position: relative;
  background: var(--editor-container-bg);
  font-family: "Inter";
  display: flex;
  flex-direction: column;
}

.ql-wrapper--focused {
  border-color: var(--editor-primary) !important;
}

.ql-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: var(--editor-container-bg);
  z-index: 10;
  border-radius: 8px;
}

.ql-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid color-mix(in srgb, var(--editor-primary) 20%, transparent);
  border-top-color: var(--editor-primary);
  border-radius: 50%;
  animation: ql-spin 0.75s linear infinite;
}

@keyframes ql-spin {
  to {
    transform: rotate(360deg);
  }
}

.ql-loading-text {
  font-family: "Inter";
  font-size: 13px;
  color: var(--editor-text);
  opacity: 0.6;
}

.ql-toolbar.ql-snow,
.ql-snow .ql-toolbar {
  background: transparent !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1.5px solid var(--editor-border) !important;
  border-radius: 0 !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  font-family: "Inter";
  transition: border-bottom-color 0.18s ease;
  flex: 0 0 auto;
}

.ql-wrapper--focused .ql-toolbar.ql-snow,
.ql-wrapper--focused .ql-snow .ql-toolbar {
  border-bottom-color: var(--editor-primary) !important;
}

.ql-snow .ql-toolbar .ql-formats {
  margin-right: 0 !important;
  margin-left: 0 !important;
  display: flex;
  align-items: center;
  gap: 2px;
}

.ql-snow .ql-toolbar button {
  width: 28px;
  height: 28px;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--editor-primary) 10%, transparent);
  box-shadow:
    0 0 0 3px color-mix(in srgb, var(--editor-primary) 12%, transparent),
    0 2px 6px color-mix(in srgb, var(--editor-primary) 18%, transparent);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease;
  padding: 0;
}

.ql-snow .ql-toolbar button:hover {
  background: color-mix(in srgb, var(--editor-primary) 20%, transparent);
  box-shadow:
    0 0 0 4px color-mix(in srgb, var(--editor-primary) 18%, transparent),
    0 3px 10px color-mix(in srgb, var(--editor-primary) 28%, transparent);
}

.ql-snow .ql-toolbar button.ql-active {
  background: color-mix(in srgb, var(--editor-primary) 25%, transparent);
  box-shadow:
    0 0 0 4px color-mix(in srgb, var(--editor-primary) 22%, transparent),
    0 3px 10px color-mix(in srgb, var(--editor-primary) 32%, transparent);
}

.ql-snow .ql-toolbar button svg .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label svg .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item svg .ql-stroke {
  stroke: var(--editor-primary);
  transition: stroke 0.15s ease;
}

.ql-snow .ql-toolbar button svg .ql-fill {
  fill: var(--editor-primary);
  transition: fill 0.15s ease;
}

.ql-snow .ql-toolbar button:hover svg .ql-stroke,
.ql-snow .ql-toolbar button.ql-active svg .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover svg .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover svg .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active svg .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected svg .ql-stroke {
  stroke: var(--editor-primary);
}

.ql-snow .ql-toolbar button:hover svg .ql-fill,
.ql-snow .ql-toolbar button.ql-active svg .ql-fill {
  fill: var(--editor-primary);
}

.ql-snow .ql-toolbar .ql-picker {
  color: var(--editor-primary);
}

.ql-snow .ql-toolbar .ql-picker-label {
  width: 28px;
  height: 28px;
  border-radius: 50% !important;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--editor-primary) 10%, transparent);
  box-shadow:
    0 0 0 3px color-mix(in srgb, var(--editor-primary) 12%, transparent),
    0 2px 6px color-mix(in srgb, var(--editor-primary) 18%, transparent);
  color: var(--editor-primary);
  padding: 0;
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease;
}

.ql-snow .ql-toolbar .ql-picker-label:hover {
  background: color-mix(in srgb, var(--editor-primary) 20%, transparent);
  box-shadow:
    0 0 0 4px color-mix(in srgb, var(--editor-primary) 18%, transparent),
    0 3px 10px color-mix(in srgb, var(--editor-primary) 28%, transparent);
}

.ql-snow .ql-toolbar .ql-picker-options {
  background: var(--editor-container-bg);
  border: 1px solid var(--editor-border) !important;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.ql-snow .ql-toolbar .ql-picker-item {
  color: var(--editor-text);
  border-radius: 50px;
  transition:
    box-shadow 0.15s ease,
    color 0.15s ease;
}

.ql-snow .ql-toolbar .ql-picker-item:hover {
  box-shadow: 0 0 0 6px
    color-mix(in srgb, var(--editor-primary) 10%, transparent);
  background: color-mix(in srgb, var(--editor-primary) 10%, transparent);
}

.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: var(--editor-primary);
  background: color-mix(in srgb, var(--editor-primary) 12%, transparent);
  box-shadow: 0 0 0 6px
    color-mix(in srgb, var(--editor-primary) 12%, transparent);
  border-radius: 50px;
}

.ql-container.ql-snow {
  font-family: "Inter";
  font-size: 15px;
  border: none !important;
  border-radius: 0 !important;
  background: var(--editor-container-bg);
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.ql-editor {
  padding: 10px 16px;
  color: var(--editor-text);
  font-family: "Inter";
  line-height: 1.6;
  min-height: 200px;
}

.ql-editor.ql-blank::before {
  color: var(--color-slate-default) !important;
  font-style: normal;
  font-family: "Inter";
}

.ql-toolbar.ql-snow .ql-stroke,
.ql-toolbar.ql-snow .ql-picker-label .ql-stroke {
  stroke: var(--editor-text) !important;
}

.ql-toolbar.ql-snow .ql-fill {
  fill: var(--editor-text) !important;
}

.ql-toolbar.ql-snow .ql-picker,
.ql-toolbar.ql-snow .ql-picker-label {
  color: var(--editor-text) !important;
}

/* Active / selected formats keep the primary accent. */
.ql-toolbar.ql-snow button.ql-active .ql-stroke,
.ql-toolbar.ql-snow .ql-picker-label.ql-active .ql-stroke {
  stroke: var(--editor-primary) !important;
}

.ql-toolbar.ql-snow button.ql-active .ql-fill {
  fill: var(--editor-primary) !important;
}
